// app/javascript/controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.hideTimeout = null
    // ドロップダウンが正しく動作するように初期状態を設定
    this.menuTarget.classList.add("hidden")
  }

  show() {
    // 既存のタイムアウトをキャンセル
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    // メニューを表示
    this.menuTarget.classList.remove("hidden")
  }

  hide() {
    // 少し遅延してメニューを隠す（マウスの移動時間を考慮）
    this.hideTimeout = setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 300)
  }

  disconnect() {
    // コントローラが削除される際にタイムアウトをクリア
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }
}
